//
import Empresa from '../../shared/entity/Empresa';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { StackParamList } from '../../../App';
import empresaApi from '../../apis/empresaApi';
import colors from '../../colors';
import { SIDE_PADDING, TXT_M, TXT_GG, TXT_G } from '../../constants';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import ApresentacaoEmpresa from '../ProdutosPage/ApresentacaoEmpresa';
import Title from '../Generic/Title';
import Touchable from '../Generic/Touchable';
import MiniInfo from '../Generic/MiniInfo';
import { useEmpresas } from '../../redux/empresas/empresasHooks';

type Props = {
  navigation: StackNavigationProp<StackParamList, 'SelecionarFilialPage'>;
};

const SelecionarFilialPage: React.FC<Props> = (props) => {
  const { navigation } = props;
  const [loading, setLoading] = useState(true);
  const [empresaRedux, setEmpresa] = useEmpresa();
  const [empresas] = useEmpresas();

  const selecionarEmpresa = async (novaEmpresa: Empresa) => {
    novaEmpresa = await empresaApi.getOne({ id: novaEmpresa.id });
    setEmpresa(novaEmpresa);
    navigation.navigate('HomeDrawer');
  };

  useEffect(() => {
    if (empresas.length > 0) {
      setLoading(false);
    }
    if (empresas.length === 1) {
      setEmpresa(empresas[0]);
      navigation.replace('HomeDrawer');
    }
  }, [empresas]);

  return (
    <PageContainer
      containerStyle={styles.container}
      // style={{ justifyContent: 'space-between', flex: 1, height: '100%' }}
      padding={false}
      header={<Header />}
      loading={loading}
    >
      <ApresentacaoEmpresa mostrarInfos={false} />
      <View style={{ paddingLeft: SIDE_PADDING, paddingRight: SIDE_PADDING }}>
        <Title style={{ marginBottom: 20 }}>Selecione uma filial:</Title>
        {empresas.map((empresa) => (
          <Touchable
            key={empresa.id}
            style={styles.card}
            onPress={() => selecionarEmpresa(empresa)}
          >
            <View style={{ flexDirection: 'row' }}>
              <View style={{ flex: 1, marginRight: 10 }}>
                <Text style={styles.subtitulo}>{empresa.nome}</Text>
                {empresa.endereco !== '' && <Text>{empresa.endereco}</Text>}
              </View>
              {empresa.aberto ? (
                <MiniInfo backgroundColor={colors.green}>ABERTO</MiniInfo>
              ) : (
                <MiniInfo backgroundColor={colors.red}>FECHADO</MiniInfo>
              )}
            </View>
          </Touchable>
        ))}
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    width: '100%',
    // backgroundColor: '#ff0',
    justifyContent: 'space-between',
    flexGrow: 1
  },
  card: {
    borderWidth: 1,
    borderColor: colors.divider,
    borderRadius: 7,
    padding: 10,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 15
  },
  subtitulo: {
    fontSize: TXT_G,
    fontWeight: '700',
    marginBottom: 5
    // color: colors.darkGrey
  }
});

export default SelecionarFilialPage;
